<template>
  <div>
    <v-combobox
      v-if="arrayWidget === 'chips'"
      :value="value || []"
      :label="label"
      :hint="field.type === 'array:int' ? 'Enter number, press Enter' : 'Enter text, press Enter'"
      persistent-hint
      multiple
      chips
      small-chips
      deletable-chips
      clearable
      outlined
      class="mb-4"
      :disabled="readonly"
      @input="onArrayInput"
    />
    <smart-select
      v-else
      :value="isSingle ? singleArrayValue : (value || [])"
      :items="arrayItems"
      :item-text="sourceItemText"
      :item-value="sourceItemValue"
      :label="label"
      :loading="sourceLoading"
      :disabled="readonly"
      :multiple="!isSingle"
      @input="isSingle ? onSingleArrayInput($event) : onArrayInput($event)"
    />
  </div>
</template>

<script>
import fieldSource from '../../mixins/fieldSource'

export default {
  name: 'ArrayField',
  components: {
    SmartSelect: () => import('../../SmartSelect.vue'),
  },
  mixins: [fieldSource],
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    field: {
      type: Object,
      required: true,
    },
    siblingValues: {
      type: Object,
      default: () => ({}),
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedEnum() {
      if (!this.field.enum) {
        return []
      }
      return this.field.enum.map(item => {
        if (typeof item === 'string') {
          return { value: item, label: item }
        }
        return { value: item.value || '', label: item.label || item.value || '' }
      })
    },
    arrayWidget() {
      if (this.field.widget) {
        return this.field.widget
      }
      return (this.field.enum || this.hasSource) ? 'multi' : 'chips'
    },
    isSingle() {
      return this.arrayWidget === 'single'
    },
    arrayItems() {
      return this.hasSource ? this.sourceItems : this.normalizedEnum
    },
    singleArrayValue() {
      if (Array.isArray(this.value)) {
        return this.value.length ? this.value[0] : null
      }
      return this.value != null ? this.value : null
    },
  },
  watch: {
    sourceDependsValue() {
      if (this.hasSource) {
        this.loadSourceItems()
      }
    },
  },
  created() {
    if (this.hasSource) {
      this.loadSourceItems()
    }
  },
  methods: {
    coerceArray(val) {
      const arr = Array.isArray(val) ? val : (val == null ? [] : [val])
      if (this.field.type === 'array:int') {
        return arr.map(v => parseInt(v)).filter(v => !isNaN(v))
      }
      return arr
    },
    onArrayInput(val) {
      this.$emit('input', this.coerceArray(val))
    },
    onSingleArrayInput(val) {
      this.onArrayInput(val == null || val === '' ? [] : [val])
    },
  },
}
</script>
